import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd, ActivatedRoute, RouterModule } from '@angular/router';

import { IconSetService } from '@coreui/icons-angular';
import { freeSet } from '@coreui/icons';
import { environment } from '../environments/environment';
import { filter, Subscription } from 'rxjs';
import { SeoService } from './core/services/seo/seo.service';

@Component({
  selector: 'body',
  standalone: true,
  imports: [RouterModule],
  template: '<router-outlet></router-outlet>',
  providers: [IconSetService],
})
 

export class AppComponent implements OnInit, OnDestroy {
  private routerSub!: Subscription;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private seoService: SeoService,
    public iconSet: IconSetService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    // iconSet singleton
    iconSet.icons = { ...freeSet };
  }

  ngOnInit() {
    const isBrowser = isPlatformBrowser(this.platformId);
    let hasGA = false;
    const win = window as any;

    // Google Analytics is browser-only (DOM script injection). Skip entirely during SSR.
    if (isBrowser && environment.googleAnalyticsId) {
      hasGA = true;

      // Inject Google Tag Manager script
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${environment.googleAnalyticsId}`;
      document.head.appendChild(script);

      // Setup dataLayer and gtag function
      win.dataLayer = win.dataLayer || [];
      win.gtag = win.gtag || function() {
        win.dataLayer.push(arguments);
      };

      win.gtag('js', new Date());
      win.gtag('config', environment.googleAnalyticsId, { send_page_view: false });
    }

    this.routerSub = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((evt: any) => {
      // Scroll + analytics page_view are browser-only; SEO update below runs on the server too.
      if (isBrowser) {
        window.scrollTo(0, 0);

        // Send page view event to Google Analytics
        if (hasGA && win.gtag) {
          win.gtag('event', 'page_view', {
            page_path: evt.urlAfterRedirects,
            page_title: document.title,
            page_location: window.location.href
          });
        }
      }

      // Traversal to active leaf route data
      let route = this.activatedRoute;
      while (route.firstChild) {
        route = route.firstChild;
      }

      // Update SEO from route metadata
      route.data.subscribe(data => {
        // Dynamic detail components should manage their own SEO headers
        if (data['skipGlobalSeo']) {
          return;
        }

        if (data['seo']) {
          this.seoService.updateSeo(data['seo']);
        } else if (data['title']) {
          this.seoService.updateSeo({ title: data['title'] });
        } else {
          this.seoService.resetToDefaults();
        }
      });
    });
  }

  ngOnDestroy(): void {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }
}